/**
 * The French URLs ada shipped with (07/10/2026), still found in sent emails and bookmarks:
 * mapped to their English equivalents, query parameters and tab values included.
 */
const PATHS: Array<[RegExp, string]> = [
  [/^\/projets(?=\/|$)/, "/projects"],
  [/^\/mes-demandes$/, "/my-requests"],
  [/^\/cra\/tous$/, "/reports/team"],
  [/^\/cra$/, "/reports"],
  [/^\/connecter-claude$/, "/integrations"],
  [/^\/admin\/demandes$/, "/admin/requests"],
  [/^\/admin\/projets$/, "/admin/projects"],
  [/^\/admin\/personnes$/, "/admin/people"],
  [/^\/admin\/cra$/, "/admin/reports"],
  [/^\/admin\/parametres$/, "/admin/settings"],
];

const PARAMS: Record<string, string> = {
  semaine: "week",
  du: "from",
  au: "to",
  projet: "project",
  statut: "status",
  techno: "technology",
  mes: "mine",
  nouveau: "new",
  onglet: "tab",
};

const TABS: Record<string, string> = {
  presentation: "overview",
  cra: "reports",
  historique: "history",
  personnes: "people",
  regle: "rule",
  comptes: "accounts",
  synchro: "sync",
};

/** The English URL for a legacy French one, or null when `pathname` is not a legacy path. */
export function englishUrl(pathname: string, search: string): string | null {
  const match = PATHS.find(([re]) => re.test(pathname));
  if (!match) return null;
  const path = pathname.replace(match[0], match[1]);
  const params = new URLSearchParams();
  for (const [key, value] of new URLSearchParams(search)) {
    const name = PARAMS[key] ?? key;
    params.append(name, name === "tab" ? (TABS[value] ?? value) : value);
  }
  const query = params.toString();
  return query ? `${path}?${query}` : path;
}
